import rivalGamesLogoRed from "../static/images/logos/Rival-Parent-Logo.png";
import rivalGamesLogoWhite from "../static/images/logos/Rival-Logo-White.svg";

export const logoWhite = path => rivalGamesLogoWhite;

export const logoRed = path => rivalGamesLogoRed;
